import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RESET_STATE } from "../actionTypes";
import { getUserMenusAction } from "../actions";
import { getIsLoading, getData, getTrees } from "../selectors";
import { Grid } from "@material-ui/core";
import DataItem from "./data/dataItem";
import ABMLayout from "@icarius-common/abmComponents/abmLayout";
import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

const UserMenus = ({ history }) => {

  const [createIsOpen, setCreateIsOpen] = useState(false);

  const dispatch = useDispatch();
  const isLoading = useSelector(getIsLoading);
  const data = useSelector(getData);
  const trees = useSelector(getTrees);

  useEffect(() => {
    dispatch(getUserMenusAction());
    return () => { dispatch({ type: RESET_STATE }) }
  }, [dispatch])

  const getDataIsEmpty = () => {
    return !data || data.length === 0;
  }

  const handleGoBack = () => {
    history.push(paths.extensibilityScreenSelector);
  }

  return (
    <ABMLayout
      title={getLocalizedString("userMenus")}
      isLoading={isLoading}
      showCreateButton={!createIsOpen}
      createButtonTitle={getLocalizedString("newUserMenu")}
      createButtonOnClick={() => setCreateIsOpen(true)}
      showNoData={getDataIsEmpty()}
      noDataTitle={getLocalizedString("noUserMenusFound")}
      noDataCreateTitle={getLocalizedString("newUserMenu")}
      noDataOnClick={() => setCreateIsOpen(true)}
      showGoBack
      handleGoBack={handleGoBack}
    >
      {
        createIsOpen &&
        <Grid container item xs={12} style={{ margin: "10px 0px" }}>
          <DataItem
            data={null}
            trees={trees}
            closeNew={() => setCreateIsOpen(false)}
          />
        </Grid>
      }
      {
        data && data.map((item) => {
          return (
            <Grid container item xs={12} style={{ margin: "10px 0px" }} key={item.functionCode}>
              <DataItem
                data={item}
                trees={trees}
              />
            </Grid>
          )
        })
      }
    </ABMLayout>
  )
}

export default UserMenus;